import React from "react";
import { SliderCard } from "../common/Card";
import Label from "../common/Label";
import styled from "styled-components";
import { SimpleDownload } from "../common/Downloads";
import { spacing, font, breakpoints } from "../theme";
import { Image as ImageType } from "../../lib/image";
import { responsiveBackgroundImage } from "../../lib/responsiveImage";

const Image = styled.div<{ image: ImageType }>`
  width: 100%;
  padding-bottom: 75%;
  background-position: center center;
  background-size: cover;
  ${({ image }) =>
    responsiveBackgroundImage({
      image,
      sizes: {
        0: breakpoints.tiny,
        [breakpoints.tiny]: 650,
        [breakpoints.tablet]: 500
      }
    })}
`;
const StyledLabel = styled(Label)`
  color: inherit;
  display: block;
`;
const ThinStyledLabel = styled(StyledLabel)`
  font-weight: ${font.weightRegular};
`;
const Card = styled(SliderCard)`
  width: 100%;
`;
const Padded = styled.div`
  ${spacing("padding", 48)}
`;

interface Props {
  name: string;
  description?: string;
  image: ImageType;
  size: number;
}
export default function PressImageItem(p: Props) {
  return (
    <Card white>
      <Image image={p.image} />
      <Padded>
        <StyledLabel big>{p.name}</StyledLabel>
        {p.description && (
          <ThinStyledLabel small>{p.description}</ThinStyledLabel>
        )}
        <SimpleDownload title={p.name} href={p.image._src} size={p.size} />
      </Padded>
    </Card>
  );
}
